export default __webpack_public_path__ + "static/media/24.019e84f1.png";